module.exports = __webpack_public_path__ + "img/gif.4ddfb66b.png";